import React from 'react'
import { Icon } from '@iconify/react'
// material
import { alpha, styled } from '@mui/material/styles'
import { Card, CircularProgress, Typography } from '@mui/material'
// utils
import { fShortenNumber } from '../../../../utils/formatNumber'
import { dashboardApi } from '../../../../api/dashboard'

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.success.dark,
  backgroundColor: theme.palette.success.light
}))

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.success.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.success.main, 0)} 0%, ${alpha(
    theme.palette.success.dark,
    0.24
  )} 100%)`
}))

// ----------------------------------------------------------------------

export default function TotalEgressosDoutorado() {
  const [total, setTotal] = React.useState(0)
  const [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    getTotal()
  }, [])

  async function getTotal() {
    try {
      setLoading(true)
      const resp = await dashboardApi.getTotalEgressosDoutorado()
      setTotal(resp.total)
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.error(error)
    }
  }

  return (
    <RootStyle>
      <IconWrapperStyle>
        <Icon icon="ph:student-fill" width={32} height={32} />
      </IconWrapperStyle>
      {loading && <CircularProgress color="warning" />}
      {!loading && <Typography variant="h3">{fShortenNumber(total)}</Typography>}
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        Doutorado
      </Typography>
    </RootStyle>
  )
}
